import { type FC } from 'react';
import { Link, useParams } from 'react-router-dom';
import { _notNil } from '@/littledash';
import { web as webRoute } from '@/support/route';
import { parseAgentUrlSlug } from '@/components/Agents/AgentUtils';

/**
 * Placeholder page for a running agent session. Reached after kicking off an
 * agent from its setup form. The live streaming/report view is not built yet;
 * for now this confirms the session was created and shows its identifier.
 */
const AgentSessionPage: FC = () => {
  const { slug, sessionApiId } = useParams<{ slug: string; sessionApiId: string }>();
  const agentType = _notNil(slug) ? parseAgentUrlSlug(slug) : undefined;

  return (
    <div className="ph4 pb4 pt3" data-testid="agent-session-page">
      <div className="f5 mb3">
        <Link to={webRoute('agents')} className="blue link">
          In Vivo AI
        </Link>
        <span className="mh1 mid-gray">/</span>
        <span className="near-black">Session</span>
      </div>
      {_notNil(agentType) ? (
        <p className="mid-gray" data-testid="agent-session-page__placeholder">
          Session {sessionApiId} is running. The live view is coming soon.
        </p>
      ) : (
        <p className="mid-gray">Agent not found.</p>
      )}
    </div>
  );
};

export default AgentSessionPage;
